export const VIDEO_CONTENT_TYPES = [
  'video/3gpp2',
  'video/3gpp',
  'video/x-aaf',
  'video/x-ms-asf',
  'video/x-sony-avchd',
  'video/x-msvideo',
  'video/x-dirac',
  'video/x-flv',
  'video/mpeg',
  'application/x-mpegURL',
  'video/mp4',
  'video/x-matroska',
  'video/x-mng',
  'video/quicktime',
  'application/mxf',
  'video/x-nsv',
  'video/ogg',
  'application/vnd.rn-realmedia',
  'application/vnd.rn-realmedia-vbr',
  'video/x-roq',
  'video/x-svi',
  'video/vnd.vivo',
  'video/webm',
  'video/x-ms-wmv',
  'video/x-raw-yuv'
];
